<template>
  <div class="training-week-timeline">
    <div class="timeline-scroll">
      <div
        v-for="day in weekDays"
        :key="day.date"
        class="day-column"
        :class="{ 'is-today': day.isToday, 'is-match-day': day.isMatchDay }"
      >
        <div class="day-header">
          <span class="day-name">{{ day.dayName }}</span>
          <span class="day-date">{{ day.dateFormatted }}</span>
          <span class="md-label" :class="{ 'md-label-match': day.isMatchDay }">{{ day.mdLabel }}</span>
        </div>
        <div class="day-sessions">
          <SessionCard
            v-for="session in day.sessions"
            :key="session.id"
            :session="session"
            @openSession="$emit('openSession', $event)"
          />
          <div v-if="day.sessions.length === 0" class="no-sessions">
            <span>Rest day</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SessionCard from "./SessionCard.vue";

export default {
  name: "TrainingWeekTimeline",
  components: { SessionCard },
  props: {
    weekDays: { type: Array, required: true },
  },
};
</script>

<style scoped lang="scss">
.training-week-timeline {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 8px;
}

.timeline-scroll {
  display: flex;
  gap: 6px;
  width: 100%;
}

.day-column {
  flex: 1 1 0%;
  min-width: 0;
  background: #f9fafb;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  transition: all 0.2s;

  &.is-today {
    border-color: #3b82f6;
    box-shadow: 0 0 0 1px #3b82f6;
  }

  &.is-match-day {
    border-color: #ef4444;
    background: #fef2f2;
  }
}

.day-header {
  padding: 10px 10px 8px;
  text-align: center;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
}

.day-name {
  display: block;
  font-size: 0.72rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.day-date {
  display: block;
  font-size: 0.8rem;
  font-weight: 500;
  color: #1f2937;
  margin: 2px 0;
}

.md-label {
  display: inline-block;
  font-size: 0.65rem;
  font-weight: 700;
  color: #9ca3af;
  background: #f3f4f6;
  padding: 1px 8px;
  border-radius: 10px;
  letter-spacing: 0.03em;

  &.md-label-match {
    color: #fff;
    background: #ef4444;
  }
}

.day-sessions {
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 80px;
}

.no-sessions {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
  span {
    font-size: 0.72rem;
    color: #d1d5db;
    font-style: italic;
  }
}

@media (max-width: 768px) {
  .timeline-scroll {
    min-width: min-content;
  }
  .day-column {
    flex: 0 0 120px;
    min-width: 130px;
  }
}
</style>
